export const publicPages = [
  'index',
  'login',
  'error',
  'register',
  'password-reset',
  'password-reset-confirm-uid-token',
  'account-confirm-email-hash',
  'free-quote',
  'free-quote-hash',
  'magic-link-hash',
  'order-hash',
  'thanks',
  'on-the-way',

  // Invitation landing: recipient may not have an IC account yet, so they
  // MUST be able to reach /invite/<token> without being redirected to login.
  'invite-token',
]
